import { METHOD } from './method'

export const API_REVENUE = {
    COMPARISON: {
        api: '/v1/dashboard-admin/analytic/revenue/comparison',
        method: METHOD.GET,
    },
    GRAPH: {
        api: '/v1/dashboard-admin/analytic/revenue/graph',
        method: METHOD.GET,
    },
    LIST: {
        api: '/v1/dashboard-admin/analytic/revenue/list',
        method: METHOD.GET,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/analytic/revenue/export',
        method: METHOD.GET,
    },
}
